import React from 'react';
import classnames from 'classnames';
import priceLineStyles from './priceLine.module.pcss';
import productsStyles from '../../products.module.pcss';
import { PriceData } from '../../../../../../types';
import { MessagePropertiesContext } from '../../../../../../contexts/messageProperties';

interface PriceLineProps {
  price: PriceData | null;
  wasPrice: PriceData | null;
  wasWasPrice: PriceData | null;
  productStatusOnListerPage?: string | null;
  priceUponEnquiry?: boolean;
}

function PriceLine({
  price,
  wasPrice,
  wasWasPrice,
  productStatusOnListerPage,
  priceUponEnquiry = false
}: PriceLineProps): React.ReactElement | null {
  const [formattedMessage] = React.useContext(MessagePropertiesContext);
  const isPriceUponEnquiry = priceUponEnquiry || productStatusOnListerPage === 'PriceUponEnquiry';

  if (isPriceUponEnquiry) {
    return (
      <div className={priceLineStyles['price-line']}>
        {formattedMessage({ id: 'product.price.upon.enquiry', fallback: 'Price upon enquiry' })}
      </div>
    );
  }

  return (
    price && (
      <div className={priceLineStyles['price-line']}>
        {wasPrice && wasWasPrice && (
          <span
            className={classnames(
              priceLineStyles['price-line__price'],
              productsStyles['price-line__price'],
              priceLineStyles['price-line__price--was']
            )}
          >
            <s>{wasWasPrice.formattedValue}</s>
          </span>
        )}

        {wasPrice && (
          <span
            className={classnames(
              priceLineStyles['price-line__price'],
              productsStyles['price-line__price'],
              priceLineStyles['price-line__price--was']
            )}
          >
            <s>{wasPrice.formattedValue}</s>
          </span>
        )}

        <span
          itemProp="offers"
          itemScope
          itemType="http://schema.org/Offer"
          className={classnames(priceLineStyles['price-line__price'], productsStyles['price-line__price'], {
            [priceLineStyles['price-line__price--discounted']]: wasPrice
          })}
        >
          {price.formattedValue}
          <meta itemProp="price" content={price.seoFormattedValue} />
          <meta itemProp="priceCurrency" content={price.currencyIso} />
        </span>
      </div>
    )
  );
}

export default PriceLine;
